import { DocumentExporter } from '../word/utils/DocumentExporter';
import { setCurrentDocumentIdentity, type DocumentIdentity } from './reviewDocumentIdentity';

/** Reads basename + lastSaveTime/createdAt from the open Word document and caches it. */
export async function resolveDocumentIdentity(): Promise<DocumentIdentity> {
  const identity = await DocumentExporter.getDocumentIdentity();
  setCurrentDocumentIdentity(identity);
  return identity;
}
